import { TextAction } from "@/components/graphite/text-action"

/**
 * The foot of a windowed list: how many are held back, and the way to see them.
 *
 * It states the number rather than saying "Show more", because the number is
 * the fact a reader needs — whether what they are looking at is most of the
 * list or a corner of it.
 */
export function ShowMore({
  remaining,
  onShowMore,
  noun,
}: {
  remaining: number
  onShowMore: () => void
  /** Plural, lowercase: "tasks", "comments". */
  noun: string
}) {
  if (remaining <= 0) return null

  return (
    <div className="flex items-baseline gap-4 border-t py-3">
      {/*
        Named for what it opens, not just "Show more": a task list can carry one
        of these under its open rows and another under its closed ones, and two
        controls reading the same to a screen reader are two controls that
        cannot be told apart.
      */}
      <TextAction
        tone="teal"
        onClick={onShowMore}
        aria-label={`Show ${remaining} more ${noun}`}
        className="text-[12px]"
      >
        Show more
      </TextAction>
      <span className="font-mono text-[11px] text-muted-foreground">
        {remaining} more {noun}
      </span>
    </div>
  )
}
